import React from 'react'
import { SmallDivider } from 'src/components/common/Divider'
import { Noto_body1_b16, Noto_body2_m14 } from 'src/styles/fonts/NotoSansKrFonts'
import styled, { css } from 'styled-components'
import { ellip } from 'src/styles/mixin'
import { DateUtils } from 'src/utils/date'
import { Typography } from 'src/components/common/Typography'
import coupon_thumbnail_default from 'src/assets/images/coupon_thumbnail/coupon_thumbnail_circle_default.png'
import { EmptyContainer } from 'src/components/common/EmptyContainer'
import { Container } from 'src/components/common/Container'
import Button, { ButtonOption6 } from 'src/components/common/Button'
import { SelfRegCouponMainPageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponMainPage'
import { SelfRegisterCouponListSpace } from 'src/types/api'
import { Chips } from 'src/components/common/Chips'
import LazyImage from 'src/components/common/LazyImage'

const { getDayDifference, expiration7Days } = DateUtils

const SelfRegisterCard = ({
  BrandName,
  CouponName,
  CouponImage,
  ExpireDT,
  UseFlag,
  Idx,
  selfRegisterUpdatePageNav,
  selfRegisterCouponDeleteHandler,
}: Partial<SelfRegisterCouponListSpace.SelfRegisterCouponItemsType> &
  Pick<
    SelfRegCouponMainPageProps,
    'selfRegisterUpdatePageNav' | 'selfRegisterCouponDeleteHandler'
  >) => {
  const convertUseFlagToText: {
    [key: string]: { statusText: string; statusColor: string; dayChips: boolean }
  } = {
    0: { statusText: '사용 가능', statusColor: 'var(--white)', dayChips: true },
    1: { statusText: '사용 완료', statusColor: 'var(--brand-50)', dayChips: false },
    2: { statusText: '기간 만료', statusColor: 'var(--red-50)', dayChips: false },
  }
  const { statusText, statusColor, dayChips } = convertUseFlagToText[UseFlag!]

  return (
    <S.CardContainer>
      <S.CardTopContents>
        {dayChips ? (
          <Chips.Item
            size="small"
            color={`var(${expiration7Days(ExpireDT!) ? '--black-50' : '--red-50'})`}
          >
            D-{getDayDifference(ExpireDT!, 'days')}
          </Chips.Item>
        ) : (
          <EmptyContainer />
        )}
        <Typography $fontStyle={Noto_body2_m14} $color={statusColor}>
          {statusText}
        </Typography>
      </S.CardTopContents>
      <SmallDivider />
      <S.CardBottomContents>
        <LazyImage src={CouponImage || coupon_thumbnail_default} style={S.CouponImg} />
        <S.CardInfoWrap>
          <S.BrandName>{BrandName === '' ? '브랜드 미입력' : `[${BrandName}]`}</S.BrandName>
          <S.CouponName>{CouponName}</S.CouponName>
          <Container $option="flex_row" $column_gap="6px" $style={S.CouponCardButtonWrap}>
            <Button
              option={ButtonOption6('active')}
              onClickFn={() => selfRegisterUpdatePageNav(Idx!)}
            >
              수정
            </Button>
            <Button
              option={ButtonOption6('default')}
              onClickFn={() => selfRegisterCouponDeleteHandler(Idx!)}
            >
              삭제
            </Button>
          </Container>
        </S.CardInfoWrap>
      </S.CardBottomContents>
    </S.CardContainer>
  )
}

export default SelfRegisterCard

const S = {
  CardContainer: styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 20px 30px 30px;
    gap: 16px;
  `,
  CardTopContents: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  CardBottomContents: styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
  `,

  CardInfoWrap: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
  `,
  BrandName: styled.span`
    ${Noto_body2_m14};
    color: var(--black-50);
    ${ellip('line1')};
  `,
  CouponName: styled.span`
    ${Noto_body1_b16};
    ${ellip('line2')};
  `,
  CouponImg: css`
    min-width: 72px;
    width: 72px;
    height: 72px;
    border-radius: 100px;
    border: 1px solid rgba(0, 0, 0, 0.06);
  `,
  CouponCardButtonWrap: css`
    margin-top: 10px;
  `,
}
